import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './ProfileAction.scss';

function ProfileAction({
  label, disabled, fetching, onAction,
}) {
  return (
    <div className={styles.root}>
      <button
        className={classNames(
          'ui-btn',
          'ui-btn_large',
          'ui-btn_primary',
          { 'ui-btn_primary--disabled': disabled },
          styles.button,
        )}
        type="button"
        onClick={onAction}
        disabled={disabled}
      >
        {
          fetching
            ? <span className={styles.spinner} />
            : <span>{label}</span>
        }
      </button>
    </div>
  );
}

ProfileAction.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  fetching: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired,
};

ProfileAction.defaultProps = {
  disabled: false,
  fetching: false,
};

export default ProfileAction;
